import { Component, OnInit, ViewChild } from '@angular/core';
import { DatetimepickerComponent } from '../../shared/datetimepicker/datetimepicker.component';
import { Location } from '@angular/common';
import moment = require('moment');
import {BookService} from "../shared/book.service";
import { AlertService } from 'app/shared/alert.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-book-sync',
  templateUrl: './book-sync.component.html',
  styleUrls: ['./book-sync.component.scss']
})
export class BookSyncComponent implements OnInit {

  toDay: Date;
  syncDateStr: string;
  error:any={isError: false, errorMessage: ''};

  @ViewChild(DatetimepickerComponent)
  private datetimepicker: DatetimepickerComponent;

  constructor(private location: Location,
              private bookService: BookService,
              private router: Router,
              private alertService: AlertService) {}

  ngOnInit() {
    // Set default date
    this.toDay = new Date();
    this.syncDateStr = moment(this.toDay).format('DD/MM/YYYY');
    this.datetimepicker.selectDate(this.syncDateStr);
  }


  setDate(dateString: string) {
    this.syncDateStr = dateString;
    let splitSyncDateStr = this.syncDateStr.split('/');
    let syncDate = new Date(splitSyncDateStr[1] + '/' + splitSyncDateStr[0] + '/' + splitSyncDateStr[2]);
    let lastWeek = new Date();
    lastWeek.setDate(lastWeek.getDate() - 8);
    const futureDay = syncDate > this.toDay;
    const previousLW = syncDate < lastWeek;
    if (futureDay || previousLW) {
      if (futureDay) {
        this.error={isError:true,errorMessage:'La fecha seleccionada no puede ser en el futuro.'};
      } else {
        this.error={isError:true,errorMessage:'La fecha seleccionada no puede ser anterior a una semana.'};
      }
    } else {
      this.error={isError:false}
    }
  }

  back() {
    this.location.back();
  }

  onSubmit() {
    // Convert date on timestamp
    let splitDate = this.syncDateStr.split('/');
    let newFormatDate = splitDate[1] + ',' + splitDate[0] + ',' + splitDate[2];
    let timeStampDate = new Date(newFormatDate).getTime();
    this.bookService.importBook(timeStampDate/1000).subscribe();

    alert('Comienzo de sincronización de libros, puede tardar unos minutos.');
    this.router.navigate(['/book']);
  }

}



// WEBPACK FOOTER //
// ./src/app/book/book-sync/book-sync.component.ts